class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.left = this.getBoundingClientRect().left;

    this.querySelector('.header__submenu').style.setProperty('--left', `-${this.left}px`);
    window.addEventListener('resize', this.onResize.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }

  onResize() {
    this.left = this.getBoundingClientRect().left;
    this.querySelector('.header__submenu').style.setProperty('--left', `-${this.left}px`);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
